import { UiSpaBookingDTO } from '@api';
import { BookingStatus, BookingUtils } from './booking.utils';

export class ProductUtils {
  static getPrice(booking: UiSpaBookingDTO): number | undefined {
    return booking.product.flex && BookingUtils.getBookingStatus(booking) === BookingStatus.open
      ? booking.product.price
      : booking.price;
  }
}
